import React from 'react'
import { useSelector } from 'react-redux'
import styled from 'styled-components'

const CardContainer = ({ children, top, maxWidth, style = {} }) => {
  const isDark = useSelector(({ application }) => application.isDark)
  return (
    <Container top={top} style={style} maxWidth={maxWidth} isDark={isDark}>
      {children}
    </Container>
  )
}

export default CardContainer

export const PoolContainer = styled.div`
  margin: auto;
  max-width: 550px;
  width: 100%;
  background-color: ${(props) => !props.isDark && props.theme.color.background.main};
  ${({ theme }) => theme.mediaWidth.upToMedium`
  width: 80%;
  margin-top:0
  `}
`

const Container = styled.div`
  padding: ${(props) => (props.maxWidth ? '0px' : '41px 50px 45px 50px')};
  margin: auto;
  margin-top: ${(props) => `${props?.top}px` ?? '100px'};
  position: relative;
  max-width: ${(props) => props.maxWidth ?? '450'}px;
  border-radius: 39px;
  box-shadow: ${({ theme }) => theme.shadows.thin};
  ${({ theme }) => theme.mediaWidth.upToExtraSmall`
    margin-top: 30px 
  `}
  ${(props) => props.isDark && props.theme.darkMode}
`
